import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ManIcon from '../../resources/images/icons/other/man.png';
import BriefcaseIcon from '../../resources/images/icons/other/briefcase.png';

const StyledActionBox = ({ text, onClick, bgColor, hoverColor }) => {
  const theme = useTheme();

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '16px 20px',
        width: 'calc(100% - 40px)',
        maxWidth: '360px',
        margin: '8px 0',
        backgroundColor: bgColor || theme.palette.grey[200],
        cursor: 'pointer',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          width: '100%',
          backgroundColor: hoverColor || '#F6E0D4',
          '& .mainText': {
            color: theme.palette.accent.main
          },
          '& .arrowIcon': {
            color: theme.palette.accent.main
          }
        }
      }}>
      {/* Icon and text */}
      <Box display="flex" alignItems="center">
        <Typography
          variant="body1"
          className="mainText"
          sx={{
            fontWeight: 1000,
            color: theme.palette.text.primary
          }}>
          {text}
        </Typography>
      </Box>

      {/* Arrow icon */}
      <ArrowForwardIosIcon
        className="arrowIcon"
        fontSize="small"
        sx={{ color: theme.palette.text.primary }}
      />
    </Box>
  );
};

const SignUpLanding = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        width: '100%',

        mx: 'auto',
        mt: 6
      }}>
      {/* Heading */}
      <Typography
        variant="h6"
        gutterBottom
        color="accent"
        sx={{
          fontSize: '14px',
          fontWeight: 'bold',
          letterSpacing: '0.1em'
        }}>
        START YOUR INVESTMENT JOURNEY
      </Typography>

      <Typography
        variant="headingText"
        gutterBottom
        sx={{
          fontSize: '3.5em'
        }}>
        Sign Up
      </Typography>

      <Typography
        variant="body1"
        sx={{
          mb: 4
        }}>
        Select which investment journey you have with Fairtree.
      </Typography>

      {/* Option Buttons */}
      <StyledActionBox
        text="I am a direct investor"
        bgColor={theme.palette.grey[200]}
        hoverColor="#F6E0D4"
        onClick={() => navigate('/client/signup')}
      />
      <StyledActionBox
        text="I am an advisor"
        bgColor={theme.palette.grey[200]}
        hoverColor="#F6E0D4"
        onClick={() => navigate('/advisor/signup')}
      />
    </Box>
  );
};

export default SignUpLanding;
